const sessionKey = 'session';
const collapseKey = 'collapse';

const setItem = (key: string, value: any): void => localStorage.setItem(key, JSON.stringify(value));

const getItem = (key: string): any => {
  const value = localStorage.getItem(key);

  return (value) ? JSON.parse(value) : null;
};

export const setSession = (session): void => {
  setItem(sessionKey, session);
};

export const getSession = (): any => {
  return getItem(sessionKey);
};

export const deleteSession = (): void => {
  setSession(null);
};

export const setCollapse = (collapse: boolean): void => {
  setItem(collapseKey, collapse);
};

export const getCollapse = (): boolean => {
  return getItem(collapseKey);
};

export const deleteCollapse = (): void => {
  setSession(null);
};



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/services/storage.service.ts